/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import features from "../assets/features.json";

// This is method is used for boolean propety
// Example to Read the Feature in JSON file: "exampleFeature.experimentalButton.oldExperimentalButton.enable"
export const featureCheck = (featureLookup) => {
  let featureLookupArray = featureLookup.split(".");
  let featureField = features;
  for (let index = 0; index < featureLookupArray.length; index++) {
    let featureObject = featureField[featureLookupArray[index]];
    if (featureObject == null) {
      return false;
    } else {
      featureField = featureObject;
      if (index == featureLookupArray.length - 1) {
        if (typeof featureField === "boolean") {
          return featureField;
        } else {
          return false;
        }
      }
    }
  }
};
